import { Batch, HttpRequest } from '@datadog/browser-core';
export function startLoggerBatch(configuration) {
    var primaryBatch = createLoggerBatch(configuration.logsEndpointBuilder);
    var replicaBatch;
    if (configuration.replica !== undefined) {
        replicaBatch = createLoggerBatch(configuration.replica.logsEndpointBuilder);
    }
    function createLoggerBatch(endpointBuilder) {
        return new Batch(new HttpRequest(endpointBuilder, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout);
    }
    return {
        add: function (message) {
            primaryBatch.add(message);
            if (replicaBatch) {
                replicaBatch.add(message);
            }
        },
    };
}
//# sourceMappingURL=startLoggerBatch.js.map